import { createSelector } from 'reselect'

const getData = (state, data, datetime) => {
  return data
}

const getDatetime = (state, data, datetime) => {
  return datetime
}

export const makeGetDomain = () => {
  return createSelector([getData, getDatetime], (data, datetime) => {
    try {
      if (data && datetime) {

        const date = new Date(datetime)
        const datum = data[0]


        const filteredDates = data
          .filter(
            datum => new Date(datum.timestamp).getYear() === date.getYear()
          )
          .map(datum => datum.timestamp)
          .slice()
          .sort()

        const domain = filteredDates.length > 1 ? {
          x: [
            new Date(filteredDates[0]),
            new Date(filteredDates[filteredDates.length - 1])
          ]
        }: {
          x: [
            new Date(data[0]['timestamp']),
            new Date(data[data.length - 1]['timestamp'])
          ]
        }
        return domain
      } else {
        return null
      }
    } catch (error) {
      return null
    }
  })
}



// WEBPACK FOOTER //
// ./src/selectors/chartDomainSelector.js